<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/training',
          title: 'Training'
        },
        {
          href: '/training/agile-teams',
          title: 'Agile Teams'
        }
      ]"
      :value="agileTeamsPage.hero_section"
    >
      <template v-if="agileTeamsPage.hero_section.cta" #cta>
        <HeroCta :value="agileTeamsPage.hero_section.cta" />
      </template>
    </HeroSection>

    <TrainingDifferentiatorsSection
      :value="agileTeamsPage.training_differentiators_section"
      class="mb-16 hero-section hero-below-offset"
    />

    <LogoBarSection
      :items="logos"
      :value="agileTeamsPage.logo_bar_section"
      class="mb-16"
    />

    <IconDifferentiatorsSection
      class="mb-16"
      :value="agileTeamsPage.icon_differentiators_section"
    />

    <MidPageNavBar
      :nav-items="[
        {
          key: 'overview',
          title: 'Overview'
        },
        {
          key: 'compare',
          title: 'Compare'
        },
        {
          key: 'reviews',
          hidden: !reviews.length,
          title: 'Reviews'
        },
        {
          key: 'why',
          title: 'Why'
        },
        {
          key: 'contact',
          title: 'Contact Us'
        }
      ]"
      class="mb-16"
      @click="scrollToSection"
    />

    <PackageOverviewSection
      :ref="
        el => {
          sectionRefs.overview = el
        }
      "
      :value="agileTeamsPage.package_overview_section"
      class="mb-16"
    />

    <PackageComparisonSection
      :ref="
        el => {
          sectionRefs.compare = el
        }
      "
      :value="agileTeamsPage.package_comparison_section"
      class="mb-16"
    />

    <ReviewsSection
      :ref="
        el => {
          sectionRefs.reviews = el
        }
      "
      :items="reviews"
      class="mb-16"
    />

    <VerticalWhySection
      :ref="
        el => {
          sectionRefs.why = el
        }
      "
      :value="agileTeamsPage.vertical_why_section"
      class="mb-16"
    />

    <CrossSellSection
      :value="agileTeamsPage.cross_sell_section"
      class="mb-16"
    />

    <ContactCtaSection
      :ref="
        el => {
          sectionRefs.contact = el
        }
      "
      :value="agileTeamsPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from 'vue'
import { useDisplay } from 'vuetify'
import { NAV_BAR_HEIGHT } from '#root/lib/consts'
import { scrollToRefKey } from '#root/lib/utils'

const { lgAndUp } = useDisplay()
const sectionRefs = reactive({})

defineProps({
  agileTeamsPage: {
    required: true,
    type: Object
  },
  logos: {
    required: true,
    type: Array
  },
  reviews: {
    required: true,
    type: Array
  }
})

function scrollToSection({ key }) {
  scrollToRefKey(sectionRefs, key, {
    height: lgAndUp.value ? NAV_BAR_HEIGHT : 0
  })
}

onMounted(async () => {
  await scrollToRefKey(sectionRefs, undefined, {
    delay: true,
    height: lgAndUp.value ? NAV_BAR_HEIGHT : 0
  })
})
</script>
